
import { useBasicPlaceFormState } from './useBasicPlaceFormState';
import { useRestaurantFormState } from './useRestaurantFormState';
import { useHotelFormState } from './useHotelFormState';
import { useActivityFormState } from './useActivityFormState';
import { useFestivalFormState } from './useFestivalFormState';
import { useAttractionFormState } from './useAttractionFormState';
import { usePlaceFormSubmit } from './usePlaceFormSubmit';

export function usePlaceForm({ playlistId, onClose }: { playlistId: string, onClose: () => void }) {
  // Combine all the form state hooks
  const basicState = useBasicPlaceFormState();
  const restaurantState = useRestaurantFormState();
  const hotelState = useHotelFormState();
  const activityState = useActivityFormState();
  const festivalState = useFestivalFormState();
  const attractionState = useAttractionFormState();
  const { submitForm } = usePlaceFormSubmit(playlistId, onClose);

  const resetForm = () => {
    basicState.resetBasicFormState();
    restaurantState.resetRestaurantFormState();
    hotelState.resetHotelFormState();
    activityState.resetActivityFormState();
    festivalState.resetFestivalFormState();
    attractionState.resetAttractionFormState();
  };

  const handleSubmit = async (playlist?: any) => {
    const formData = {
      ...basicState,
      ...restaurantState,
      ...hotelState,
      ...activityState,
      ...festivalState,
      ...attractionState
    };
    
    const success = await submitForm(formData, playlist);
    if (success) {
      resetForm();
    }
  };

  // Return the same API as before to maintain compatibility
  return {
    ...basicState,
    ...restaurantState,
    ...hotelState,
    ...activityState,
    ...festivalState,
    ...attractionState,
    handleSubmit,
    resetForm
  };
}
